import { prefersReducedMotion } from '@theme/utilities';

/**
 * Initialize scroll animations for elements with .scroll-reveal or .scroll-zoom classes.
 * Uses IntersectionObserver for performant scroll detection.
 */
function initScrollAnimations() {
  const elements = document.querySelectorAll('.scroll-reveal:not(.is-visible), .scroll-zoom:not(.is-visible)');

  if (elements.length === 0) return;

  // If user prefers reduced motion, immediately show all elements
  if (prefersReducedMotion()) {
    elements.forEach((el) => el.classList.add('is-visible'));
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.1,
      rootMargin: '0px 0px -10px 0px',
    }
  );

  elements.forEach((el) => observer.observe(el));
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initScrollAnimations);
} else {
  initScrollAnimations();
}

// Re-initialize when Shopify sections are loaded/reloaded (for theme editor)
document.addEventListener('shopify:section:load', initScrollAnimations);

